const SynsCount = {
  MINIMUM_SYN_VALUE: 0.5,
  FREE: 'FREE',
};

export default SynsCount;
